import { activeRightStack, useActiveRightStackJid } from '@/app/store';
import { closeSidePanel } from '@/app/store/navigationSlice';
import useKeyboardNavigation from '@/shared/hooks/useKeyboardNavigation';
import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import ChatHeader from './ChatHeader';
import ConversationFooter from './ConversationFooter';
import ConversationList from './ConversationList';
import './ConversationScreen.scss';

const ConversationScreen = memo(() => {
   const activeChatJid = useActiveRightStackJid();
   const dispatch = useDispatch();

   const handleEscape = useCallback(() => {
      dispatch(activeRightStack({ activeStack: '', activeChatId: '', activeChatJid: '' }));
      dispatch(closeSidePanel());
   }, [dispatch]);

   const keyboardConfig = useMemo(() => ({ Escape: handleEscape }), [handleEscape]);

   useKeyboardNavigation(keyboardConfig, {
      enabled: !!activeChatJid,
      allowWhileTyping: true,
   });

   return (
      <div
         key={activeChatJid}
         className="conversation-screen-main ct-flex1 ct-flex ct-fcol"
         id="conversation-screen-main"
      >
         <ChatHeader activeChatJid={activeChatJid} />
         <ConversationList />
         <ConversationFooter activeChatJid={activeChatJid} />
      </div>
   );
});

export default ConversationScreen;
